import React from 'react';
import '../../../styles/achievements.css';
import achieve from '../../../assets/images/achieve.svg';

const Achievements = () => {
    return (
        <div className='Achievements'>
            <h3>Achievements</h3>
            <div className='achievementsContainer'>
            <div className='achieveContainer'>
                <div className='achieve'>
                    <h3>Vulnerability Disclosure Programs</h3>
                    <ul className='vdp'>
                        <p>I secured several companies from the security threats and got Hall of Fame and Compensation </p>
                        <li>H&M</li>
                        <li>ROKT via BugCrowd</li>
                        <li>Whimsical</li>
                        <li>Maze.co</li>
                        <li>Maxem.io</li>
                    </ul>
                </div>
                <div className='exam'>
                    <h3>Exams</h3>
                    <ul>
                        <li>In TCS National Qualifier Test, I scored 59.16% in the Foundation section, 72.45% in the Advanced section, and 80.84% in the Programming section.</li>
                        <li>Engaged in security research activities for various open-source projects.</li>
                    </ul>
                </div>
            </div>
            <div className='achieveImage'>
                    <img src={achieve} alt='achievement SVG illustration' />
                </div>  
            </div>
            <div className='activities'>
                <h3>Activities</h3>
                <div className='activitiesDetails'>
                    <ul>
                        <li>Participated in the inter college meet and presented about Cyber Security</li>
                        <li>Participated in the Hackthon conducted by Wikitechy</li>
                        <li>Participated in online hacking playgrounds such as HackTheBox and TryHackMe</li>
                    </ul>
                    <div className='badgesContainer'>
                        <h3>Badges</h3>
                        <div className='badges'>
                            <div>
                                <h3>HackTheBox</h3>
                                <img src="http://www.hackthebox.eu/badge/image/392420" alt="Hack The Box" />
                            </div>
                            <div>
                                <h3>TryHackMe</h3>
                                <img src="https://tryhackme-badges.s3.amazonaws.com/karthikgohul.png" alt="TryHackMe" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Achievements;